import * as React from "react";
const NewsGuide = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.6977 9.06977C10.6977 8.68445 10.3853 8.37209 10 8.37209C9.61469 8.37209 9.30233 8.68445 9.30233 9.06977V14.6512C9.30233 15.0365 9.61469 15.3488 10 15.3488C10.3853 15.3488 10.6977 15.0365 10.6977 14.6512V9.06977Z"
      fill="#184548"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM1.39535 10C1.39535 5.24778 5.24778 1.39535 10 1.39535C14.7522 1.39535 18.6047 5.24778 18.6047 10C18.6047 14.7522 14.7522 18.6047 10 18.6047C5.24778 18.6047 1.39535 14.7522 1.39535 10Z"
      fill="#184548"
    />
    <path
      d="M10.9302 6.27907C10.9302 6.79282 10.5138 7.2093 10 7.2093C9.48624 7.2093 9.06976 6.79282 9.06976 6.27907C9.06976 5.76532 9.48624 5.34884 10 5.34884C10.5138 5.34884 10.9302 5.76532 10.9302 6.27907Z"
      fill="#184548"
    />
  </svg>
);
export default NewsGuide;
